// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 672 ? "bootstrap" : chunkId) + "." + {"496":"c6456e17","672":"3508dbb4"}[chunkId] + ".chunk.js";
};